import React from "react";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import SignUpForm from "../components/SignUpForm";
import HeaderShell from "../components/Header/HeaderShell";
import Footer from "../components/Footer";

export default function Demo() {
  const subtitleStyles = { marginBottom: "1rem" };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <HeaderShell />
      <Container
        maxWidth="lg"
        sx={{
          paddingTop: "4rem",
          justifyContent: "flex-start",
          textAlign: "left",
        }}
      >
        <Grid container spacing={6}>
          <Grid item xs={12} sm={12} md={12}>
            <Typography
              variant="h1"
              sx={{ fontSize: { xs: "1.5rem", sm: "2rem", md: "3rem" } }}
            >
              Schedule a demo
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={5}>
            <Typography variant="h6" sx={subtitleStyles}>
              Good Blocks is currently in an invite-only stage.
            </Typography>
            <Typography variant="body1" color="grey.main" sx={subtitleStyles}>
              Please complete the form below to schedule a demo.
            </Typography>
            <SignUpForm />
          </Grid>
          <Grid item xs={12} sm={12} md={7} container justifyContent="center">
            <Box
              component="img"
              align="right"
              sx={{
                display: "flex",
                paddingTop: "48px",
                height: "450px",
              }}
              alt="Person drawing school boundaries with large pencil."
              src="https://sde-resources.s3.amazonaws.com/img/drawer.svg"
            />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </Box>
  );
}
